import { useMediaQuery } from 'react-responsive';
import { MainPage } from './MainPage';
import React from 'react';
import { MobileMainPage } from './mobile/MobileMainPage';

export const Preorder = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 1200px)' });
  return isMobile ? <MobileMainPage /> : <MainPage />;
};
